module.exports = __webpack_public_path__ + "img/philipp.969f832f.jpg";